/**
 *
 * BlockFreemiumPageBlur
 *
 */

import React from "react"
import { Link, withRouter } from "react-router-dom"
import { requestUpgradeApi } from "services/requestUpgrade"
import "./index.less"
import _img_leadership_dimension from "images/freemium/leadership-by-dimension.svg"
import _img_leadership_leaders from "images/freemium/leadership-by-leaders.png"
import _img_engagement_division from "images/freemium/engagement-by-division.svg"
import _img_engagement_dimension from "images/freemium/engagement-by-dimension.svg"
import _img_engagement_qualitative from "images/freemium/engagement-qualitative.svg"
import _img_leadership_qualitative from "images/freemium/leadership-qualitative.svg"
import _img_action_plans from "images/freemium/action-plans.svg"
import _img_recommendations from "images/freemium/recommendations.svg"

function BlockFreemiumPageBlur({ match, view, position, top, topHeight }) {
  const isFreemium = window.freemium()
  const idMedition = match ? `measure/${match.params.id}` : ""
  const renderContent = () => {
    let title
    let description
    let image
    let maxWidthContent = 600
    let backToReports = true
    let callToActionDescription = (
      <p>
        Para adquirir la <b>versión completa</b> de la plataforma, haz{" "}
        <span
          className="color-blue"
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => requestUpgradeApi()}>
          click aquí
        </span>{" "}
        y nuestro equipo comercial te <b>contactará</b> a la brevedad.
      </p>
    )
    switch (view) {
      case "leadership-dimension-by-team":
        title =
          "Lo sentimos, pero no tienes acceso a ver el análisis detallado por dimensión 😢"
        image = _img_leadership_dimension
        description = (
          <>
            <p>
              En esta sección podrás analizar las <b>respuestas</b> a las
              distintas preguntas, subdimensiones y dimensiones del
              cuestionario, divididas por <b>posturas</b> (desfavorable, neutro
              y favorable).
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "leadership-rank-leaders":
        title =
          "Lo sentimos, pero no tienes acceso al análisis detallado por líderes 😢"
        image = _img_leadership_leaders
        description = (
          <>
            <p>
              En esta sección podrás analizar los <b>resultados</b> de tu
              medición con mayor detalle a nivel de cada <b>líder</b> evaluado.
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "engagement-result-division":
        title =
          "Lo sentimos, pero no tienes acceso a ver el análisis detallado por división 😢"
        image = _img_engagement_division
        description = (
          <>
            <p>
              En esta sección podrás analizar los resultados de tu medición con
              mayor <b>detalle</b> para cada <b>división</b> encuestada.
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "engagement-result-dimension":
        title =
          "Lo sentimos, pero no tienes acceso a ver el análisis detallado por dimensión 😢"
        image = _img_engagement_dimension
        description = (
          <>
            <p>
              En esta sección podrás analizar las <b>respuestas</b> a las
              distintas preguntas, subdimensiones y dimensiones del
              cuestionario, divididas por <b>posturas</b> (desfavorable, neutro
              y favorable).
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "engagement-qualitative-question":
        maxWidthContent = 445
        title =
          "Lo sentimos, pero no tienes acceso a la visualización de todas las respuestas cualitativas 😢"
        image = _img_engagement_qualitative
        description = (
          <>
            <p>
              En esta sección podrás visualizar todas las <b>respuestas</b> a
              las preguntas cualitativas obtenidas en la medición.
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "leadership-qualitative-question":
        maxWidthContent = 445
        title =
          "Lo sentimos, pero no tienes acceso a la visualización de todas las respuestas cualitativas 😢"
        image = _img_leadership_qualitative
        description = (
          <>
            <p>
              En esta sección podrás visualizar todas las <b>respuestas</b> a
              las preguntas cualitativas obtenidas en la medición.
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "action-plans":
        backToReports = false
        title =
          "Lo sentimos 😢, pero no tienes acceso a crear Planes de acción."
        image = _img_action_plans
        description = (
          <>
            <p>
              Un <b>Plan de acción</b> tiene la intención de mejorar el
              resultado de una dimensión a través de iniciativas a ejecutar a lo
              largo del periodo.
            </p>
            {callToActionDescription}
          </>
        )
        break

      case "recommendations":
        maxWidthContent = 570
        backToReports = false
        title = "Lo sentimos 😢, pero no tienes acceso a crear Recomendaciones."
        image = _img_recommendations
        description = (
          <>
            <p>
              Las <b>Recomendaciones</b> te permiten crear planes de acción{" "}
              <b>modelo</b> que luego los embajadores de tu organización podrán
              visualizar y seleccionar al momento de crear sus propios planes de
              acción.
            </p>
            {callToActionDescription}
          </>
        )
        break
      default:
        break
    }
    return {
      title,
      description,
      image,
      maxWidthContent,
      backToReports,
    }
  }

  if (!isFreemium) {
    return false
  }

  return (
    <div
      className="BlockFreemiumPageBlurComponent"
      style={{ top, position, minHeight: `calc(100vh - ${topHeight}px)` }}>
      <div className="BlockFreemiumPageBlurComponent-content text-center">
        {renderContent().image && <img src={renderContent().image} />}
        <div
          style={{
            margin: "0 auto",
            maxWidth: renderContent().maxWidthContent,
          }}>
          <span className="BlockFreemiumPageBlurComponent-content-title">
            {renderContent().title}{" "}
          </span>
          <div className="BlockFreemiumPageBlurComponent-content-description">
            {renderContent().description}
          </div>
          {renderContent().backToReports && (
            <div className="BlockFreemiumPageBlurComponent-content-description">
              <Link to={`/reports/${idMedition}`}>
                &lt; Regresar a Reportes
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

BlockFreemiumPageBlur.defaultProps = {
  view: "leader",
  top: null,
  position: "fixed",
  topHeight: 54,
}

export default React.memo(withRouter(BlockFreemiumPageBlur))
